import moment from "moment-timezone";

export const roundTimetoStartHour = (startArg: string) => {
    const format = "YYYY-MM-DDTHH:mm";
    const roundedDate = moment(startArg)?.startOf("hour")?.format(format);
    return roundedDate === 'Invalid date' || !roundedDate ? '' : roundedDate;
  }